export default "__VITE_ASSET__CGbX7$zC__$_?inline__"